import React, { Component } from 'react'
import classes from './hatNav.css'
import message from '../../../img/download.png'
import sendMessage from '../../../img/email.png'
import call from '../../../img/home.png'
import BurgerMenu from '../../../hoc/Menu/Burger-menu'
import { NavLink } from 'react-router-dom'


class HatNav extends Component {
    render() {
        return (
            <div className={classes.hatNav}>
                <div className='container'>
                    <div className='row'>

                        <div className='col'>

                            <BurgerMenu />


                            <ul className={classes.Nav}>

                                <li ><a href=''><img className={classes.liIcon} width="20px" src={message} alt=''></img></a></li>
                                <li ><a href=''><img className={classes.liIcon} width="20px" src={sendMessage} alt=''></img></a></li>
                                <li ><a href=''><img className={classes.liIcon} width="20px" src={call} alt=''></img></a></li>
                                <li><div className={classes.navBlock}><NavLink to='/'>главная</NavLink></div></li>
                                <li><div className={classes.navBlock}><a href='/akes'>акэс</a></div></li>
                                <li><div className={classes.navBlock}><NavLink to='/collector/construction'>солнечный коллектор в акЭС</NavLink></div></li>
                                <li><div className={classes.navBlock}><a href='/transmission'> система приёма передачи энергии в акЭС</a></div></li>
                                <li><div className={classes.navBlock}><NavLink to='/feadback'>обратная связь</NavLink></div></li>
                            </ul>
                        </div>


                    </div>
                </div>


            </div>
        )
    }
}
export default HatNav


// WEBPACK FOOTER //
// ./src/containers/Hat/hatNav/hatNav.js